module.exports = __webpack_public_path__ + "static/media/download-solid-full.a7b5a340.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/download-solid-full.svg
// module id = 379
// module chunks = 0